import { isProd, isCdt } from "@/config/constants";

const ACCOUNT_BASE_URL = isProd
    ? "https://api.maersk.com/bowlerchart-data-api/api/"
        : isCdt
            ? "https://api-cdt.maersk.com/bowlerchartdata/api/"
            : "http://localhost:8081/api/";

//Generic Bowler Chart
export const getProductList = `${ACCOUNT_BASE_URL}getProductList`;
export const retrieveProductDetails = `${ACCOUNT_BASE_URL}retrieveProductDetails`;
export const getProductFilters = `${ACCOUNT_BASE_URL}getProductFilters`;
export const getMetricLevelDetails = `${ACCOUNT_BASE_URL}getMetricLevelDetails`;
export const saveMetricActionAssignment = `${ACCOUNT_BASE_URL}saveMetricActionAssignment`;
export const updateMetricActionAssignment = `${ACCOUNT_BASE_URL}updateMetricActionAssignment`;
export const retrieveMetricActionAssignment = `${ACCOUNT_BASE_URL}retrieveMetricActionAssignment`;
export const updateMetricOwner = `${ACCOUNT_BASE_URL}updateMetricOwner`;
export const retrieveAllMetricOwners = `${ACCOUNT_BASE_URL}retrieveAllMetricOwners`;
export const retrieveOwnerFilters = `${ACCOUNT_BASE_URL}retrieveOwnerFilters`;
export const getProductListForEdit = `${ACCOUNT_BASE_URL}getProductListForEdit`;
export const getProductUserPageFilters = `${ACCOUNT_BASE_URL}getProductUserPageFilters`;
export const retrieveAllUsersForProduct = `${ACCOUNT_BASE_URL}retrieveAllUsersForProduct`;
export const deleteUserAccess = `${ACCOUNT_BASE_URL}deleteUserAccess`;
export const retrieveAllUsersToBeApprovedForProduct = `${ACCOUNT_BASE_URL}retrieveAllUsersToBeApprovedForProduct`;
export const addProductUser = `${ACCOUNT_BASE_URL}addProductUser`;
export const retrieveUserAccess = `${ACCOUNT_BASE_URL}retrieveUserAccess`;
export const requestProductAccess = `${ACCOUNT_BASE_URL}requestProductAccess`;
export const updateUserAccessRequest = `${ACCOUNT_BASE_URL}updateUserAccessRequest`;
export const deleteMetricActionAssignment = `${ACCOUNT_BASE_URL}deleteMetricActionAssignment`;
export const verifyDrillDownTabData = `${ACCOUNT_BASE_URL}verifyDrillDownTabData`;
export const saveBowlerChartFeedback = `${ACCOUNT_BASE_URL}saveBowlerChartFeedback`;
export const getAllRaisedFeedback = `${ACCOUNT_BASE_URL}getAllRaisedFeedback`;
export const updateFeedbackStatus = `${ACCOUNT_BASE_URL}updateFeedbackStatus`;
export const saveUserDashboardFilter = `${ACCOUNT_BASE_URL}saveUserDashboardFilter`;
export const getUserDashboardFilter = `${ACCOUNT_BASE_URL}getUserDashboardFilter`;
export const deleteUserDashboardFilter = `${ACCOUNT_BASE_URL}deleteUserDashboardFilter`;
export const getDashboardFilterNames = `${ACCOUNT_BASE_URL}getDashboardFilterNames`;

